import { Box, Button, Text, VStack, Flex, useToast } from '@chakra-ui/react';
import { Card } from 'antd';
import { useGetNotesQuery } from '@/features/historic/hooks/useGetNotesQuery';
import { useState } from 'react';
import { useUserStore } from '@/stores';
import { api } from '@/lib';
import { TextInputVoice } from './TextInputVoice';
import { TextAreaInputVoice } from './TextAreaInputVoice';

export default function NotesCard({ patientId }: any) {
  const user = useUserStore(state => state.user);
  const { data: notes, refetch } = useGetNotesQuery(patientId || '');
  const [viewNotes, setViewNotes] = useState(false);

  const [notesForm, setNotesForm] = useState({
    titulo: '',
    descricao: '',
    anotacoes: '',
  });

  const toast = useToast({
    variant: 'solid',
    position: 'top-right',
    isClosable: true,
  });

  const onSubmitNotes = async () => {
    if (!notesForm.anotacoes || notesForm.anotacoes.trim() === '') {
      return toast({
        status: 'error',
        title: 'Insira a anotação',
      });
    }
    const body = {
      ...notesForm,
      usuarioPacienteId: patientId,
      usuarioProfissionalId: user?.id,
    };
    await api
      .post('/Anotacao', body)
      .then(res => {
        toast({ title: 'Anotação salva', status: 'success' });
        setNotesForm({
          titulo: '',
          descricao: '',
          anotacoes: '',
        });
      })
      .catch(err => {
        toast({
          title: err.response.data.errors[0] || 'Ocorreu um erro',
          status: 'error',
        });
      });
    return null;
  };

  return (
    <Flex flex="1">
      <Box backgroundColor="#fff" flex="1">
        <Card
          style={{
            maxHeight: '60rem',
            height: '100%',
            borderRadius: '10px',
            backgroundColor: '#fff',
            marginBottom: '30px',
          }}
        >
          <VStack
            position="relative"
            h="100%"
            backgroundColor="#fff"
            spacing="18px"
            w="100%"
            p="15"
            resize="none"
            color="#000"
            fontFamily="Rubik"
            sx={{
              '&::-webkit-scrollbar': { width: '6px' },
              '&::-webkit-scrollbar-track': { borderRadius: '8px' },
              '&::-webkit-scrollbar-thumb': {
                borderRadius: '15',
                bg: '#bfbfbf',
              },
            }}
          >
            {!viewNotes ? (
              <>
                <TextInputVoice
                  name="titulo"
                  label="Título"
                  onChange={(e: string) =>
                    setNotesForm({ ...notesForm, titulo: e })
                  }
                  value={notesForm.titulo}
                />
                <TextInputVoice
                  name="descricao"
                  label="Descrição"
                  onChange={(e: string) =>
                    setNotesForm({ ...notesForm, descricao: e })
                  }
                  value={notesForm.descricao}
                />
                <TextAreaInputVoice
                  name="anotacoes"
                  label="Anotação"
                  onChange={(e: string) =>
                    setNotesForm({ ...notesForm, anotacoes: e })
                  }
                  value={notesForm.anotacoes}
                />
              </>
            ) : (
              <Box
                style={{
                  height: 'auto',
                  maxHeight: '80%',
                  borderRadius: '10px',
                  backgroundColor: '#fff',
                  overflowY: 'auto',
                  color: '#0005',
                  width: '100%',
                }}
                sx={{
                  '&::-webkit-scrollbar': { width: '6px' },
                  '&::-webkit-scrollbar-track': { borderRadius: '8px' },
                  '&::-webkit-scrollbar-thumb': {
                    borderRadius: '15',
                    bg: '#bfbfbf',
                  },
                }}
              >
                {notes.length > 0 ? (
                  notes?.map((note: any) => (
                    <Box
                      backgroundColor="#fff"
                      border="1px solid #E4E4E4"
                      borderRadius="10"
                      padding="5"
                      marginBottom="5"
                      maxHeight="90%"
                    >
                      <Text
                        fontSize="sm"
                        w="100%"
                        color="#3D3D3D"
                        fontFamily="Rubik"
                      >
                        {note?.usuarioProfissional?.pessoa?.nome}
                      </Text>
                      <Text fontFamily="Rubik">
                        {note.anotacoes && note.anotacoes !== ''
                          ? note.anotacoes
                          : 'ANOTAÇÃO VAZIA'}
                      </Text>
                    </Box>
                  ))
                ) : (
                  <Text fontFamily="Rubik" padding="5">
                    NÃO HÁ ANOTAÇÕES
                  </Text>
                )}
              </Box>
            )}
            <Box alignSelf="flex-end">
              <Button
                type="button"
                disabled={false}
                variant="outline"
                colorScheme="teal"
                py="12px"
                px="64px"
                w={['100%', 'auto']}
                borderRadius="20px"
                color="#9F9F9F"
                fontSize="xs"
                fontWeight="600"
                textTransform="uppercase"
                _hover={{ bg: '#9F9F9F', color: 'white' }}
                onClick={() => {
                  refetch();
                  setViewNotes(!viewNotes);
                }}
              >
                {viewNotes ? 'Voltar' : 'Ver Anotações'}
              </Button>
              {!viewNotes && (
                <Button
                  type="button"
                  disabled={false}
                  variant="solid"
                  colorScheme="brand-green"
                  py="12px"
                  px="64px"
                  ml={5}
                  w={['100%', 'auto']}
                  borderRadius="20px"
                  color="white"
                  fontSize="xs"
                  fontWeight="600"
                  textTransform="uppercase"
                  _hover={{ bg: 'brand-green.default', color: 'white' }}
                  onClick={onSubmitNotes}
                >
                  Salvar Anotação
                </Button>
              )}
            </Box>
          </VStack>
        </Card>
      </Box>
    </Flex>
  );
}
